import { useRootProps, useUserData } from '../components/UserDataProvider';
import { TYPES } from './types';

export default function useLogoHref() {
  const { privateLabelId, urls, requestedHeader } = useRootProps();
  const { userData, userDataLoaded } = useUserData();
  const pcx = userDataLoaded && userData && userData.pcx ? userData.pcx : false;

  if (requestedHeader === TYPES.partners && privateLabelId === 1) {
    return urls.proHome.href;
  }

  // if pcx redirect to hub else redirect to vh redirect link
  if (privateLabelId === 1) {
    if (pcx) {
      return urls.proHub.href;
    }
    return urls.vhLogoLink.href;
  }
  return urls.home.href;
}
